import styles from "./route-source-section-modals.module.css";
import { Modal } from "BEDROCK/shared-components/modal";
import { UIIcon } from "PosterEditor/common-components/ui-icon-drawing/ui-icon";
import { GPXUploadButton } from "PosterEditor/common-components/gpx-upload-button";
import { CTAButton } from "BEDROCK/shared-components/cta-button";

interface RouteSourceSectionModalStravaProps {
  isOpen: boolean;
  onClose: () => void;
}

export const RouteSourceSectionModalStrava = (
  props: RouteSourceSectionModalStravaProps
) => {
  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose}>
      <div className={styles.container} style={{ width: "400px" }}>
        <div className={styles.titleBar}>
          <UIIcon iconName="STRAVA" size={28} variant="REGULAR" />
          <h1>Get your route from Strava</h1>
        </div>
        <div className={styles.content}>
          <ol>
            <li>
              Sign in to the{" "}
              <a
                href="https://www.strava.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Strava.com
              </a>
            </li>
            <li>Go the page for your activity</li>
            <li>Click on the three dots button in the left toolbar</li>
            <li>
              Click "Export GPX" to save it to your computer, then come back
              here and click the button below
            </li>
          </ol>
          <a
            className={styles.gifContainer}
            href="https://strava.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className={styles.stravaGif}
              src="/hint-gifs/gpx-from-strava.gif"
              alt="GPX file from Strava"
            />
          </a>
          <GPXUploadButton>
            <CTAButton variant="SECONDARY">Upload file to TrailArt</CTAButton>
          </GPXUploadButton>
        </div>
      </div>
    </Modal>
  );
};
